<template>
  <div class="about container has-text-left">
    <h1 class="title is-4 is-font-sans is-color-pff-light-blue">About</h1>
    <p class="is-size-5">{{this.$store.getters.getAbout}}</p>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style scoped>
.about {
  text-align: center;
  padding: 10vh 2rem 0 2rem;
}
</style>

